import produce from "immer";
import { createAction, createReducer } from "redux-act";
import { GeometrySelectionState, setGeometrySelection } from "../geometrySelection/geometrySelection";
import { reducerRegistry } from "../reducerRegistry";
import { ZoomSelectionState } from "./types";

export const reducerName = "zoomSelection";

const initialState: ZoomSelectionState = {
  zoomInEnabled: false,
  zoomOutEnabled: false,
};

export const setZoomInEnabled = createAction<boolean>("zoomSelection/set-zoom-in");
export const setZoomOutEnabled = createAction<boolean>("zoomSelection/set-zoom-out");
export const reducer = createReducer({}, initialState);

reducer.on(
  setZoomInEnabled,
  produce((snappingState: ZoomSelectionState, enabled: boolean) => {
    snappingState.zoomInEnabled = enabled;
    snappingState.zoomOutEnabled = false;
  }),
);

reducer.on(
  setZoomOutEnabled,
  produce((snappingState: ZoomSelectionState, enabled: boolean) => {
    snappingState.zoomOutEnabled = enabled;
    snappingState.zoomInEnabled = false;
  }),
);

reducer.on(
  setGeometrySelection,
  produce((snappingState: ZoomSelectionState, state: GeometrySelectionState) => {
    if (state.active) {
      snappingState.zoomOutEnabled = false;
      snappingState.zoomInEnabled = false;
    }
  }),
);

reducerRegistry.register(reducerName, reducer);
